import React from 'react'

import { Table } from '../../../../../../Components/FinalTable'

import TableHeader from './TableHeader'

import TBody from './TBody'

import TableInfoSection from './TableInfoSection'

const AllProceduresTable = () => {
  return (
    <Table>
      <TableHeader />
      <TBody />
      <TableInfoSection />
    </Table>
  )
}

export default AllProceduresTable